import $ from 'jquery';

export default function addAsterisksToRequiredFormFields() {
    $('form.su-form :required').prev('label').each(function() {
        !$(this).text().includes('*') && $(this).addClass('required');
    });
}
